var _path, _rect, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScoreDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 131,
    viewBox: "0 0 271 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271 129H0.5V131H271V129Z",
    fill: "#EF9A9A",
    mask: "url(#path-1-outside-1_150_8590)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 270,
    height: 130,
    fill: "#FEEBEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124 130.5H124.5V130V36C124.5 32.4101 121.59 29.5 118 29.5H23C19.4101 29.5 16.5 32.4101 16.5 36V130V130.5H17H124Z",
    fill: "#FFDFE4",
    stroke: "#EF9A9A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 45,
    r: 4,
    fill: "#EF9A9A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 45,
    r: 4,
    fill: "#EF9A9A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 45,
    r: 4,
    fill: "#EF9A9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 104C29 102.895 29.8954 102 31 102H35C36.1046 102 37 102.895 37 104V130H29V104Z",
    fill: "#EF9A9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 68C44 66.8954 44.8954 66 46 66H50C51.1046 66 52 66.8954 52 68V130H44V68Z",
    fill: "#EF9A9A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88C59 86.8954 59.8954 86 61 86H65C66.1046 86 67 86.8954 67 88V130H59V88Z",
    fill: "#EF9A9A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74 100C74 98.8954 74.8954 98 76 98H80C81.1046 98 82 98.8954 82 100V130H74V100Z",
    fill: "#EF9A9A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89 77C89 75.8954 89.8954 75 91 75H95C96.1046 75 97 75.8954 97 77V130H89V77Z",
    fill: "#EF9A9A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104 118C104 116.895 104.895 116 106 116H110C111.105 116 112 116.895 112 118V130H104V118Z",
    fill: "#EF9A9A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M257 130.5H257.5V130V36C257.5 32.4101 254.59 29.5 251 29.5H141C137.41 29.5 134.5 32.4101 134.5 36V130V130.5H135H257Z",
    fill: "#FFDFE4",
    stroke: "#EF9A9A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153 106.306L140 130H257V69H251.429L239.543 83.1157L228.771 85.1322L214.657 95.2149L194.6 83.1157L172.686 95.2149L169.343 106.306H153Z",
    fill: "#FECDD2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.123 129.519C138.858 130.003 139.035 130.611 139.519 130.877C140.003 131.142 140.611 130.965 140.877 130.481L139.123 129.519ZM153 106.306V105.306H152.408L152.123 105.825L153 106.306ZM169.343 106.306V107.306H170.086L170.3 106.594L169.343 106.306ZM172.686 95.2149L172.202 94.3394L171.846 94.5363L171.728 94.9263L172.686 95.2149ZM194.6 83.1157L195.117 82.2594L194.622 81.9612L194.117 82.2403L194.6 83.1157ZM214.657 95.2149L214.141 96.0711L214.704 96.4107L215.238 96.0286L214.657 95.2149ZM228.771 85.1322L228.587 84.1493L228.37 84.19L228.19 84.3185L228.771 85.1322ZM239.543 83.1157L239.727 84.0986L240.078 84.0329L240.308 83.7598L239.543 83.1157ZM251.429 69V68H250.963L250.664 68.3559L251.429 69ZM140.877 130.481L153.877 106.787L152.123 105.825L139.123 129.519L140.877 130.481ZM153 107.306H169.343V105.306H153V107.306ZM173.169 96.0903L195.083 83.9911L194.117 82.2403L172.202 94.3394L173.169 96.0903ZM194.083 83.972L214.141 96.0711L215.174 94.3586L195.117 82.2594L194.083 83.972ZM215.238 96.0286L229.353 85.9459L228.19 84.3185L214.076 94.4012L215.238 96.0286ZM228.955 86.1152L239.727 84.0986L239.359 82.1328L228.587 84.1493L228.955 86.1152ZM240.308 83.7598L252.194 69.6441L250.664 68.3559L238.778 82.4716L240.308 83.7598ZM251.429 70H257V68H251.429V70ZM170.3 106.594L173.643 95.5035L171.728 94.9263L168.385 106.017L170.3 106.594Z",
    fill: "#EF9A9A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 45,
    r: 4,
    fill: "#EF9A9A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 45,
    r: 4,
    fill: "#EF9A9A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 45,
    r: 4,
    fill: "#EF9A9A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreDashboard);
export default __webpack_public_path__ + "static/media/score-dashboard.7627a6b0ecf598a50ea5e4e50fda4a42.svg";
export { ForwardRef as ReactComponent };